import React from 'react';
import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import { store } from './Storage';

import Routes from './Router/routes';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { receiveAuthTokenHandoff } from './Helper/authTokenHandoff';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const renderApp = () =>
  root.render(
    <Provider store={store}>
      <Routes />
    </Provider>
  );

const authHandoff = receiveAuthTokenHandoff();
if (authHandoff) {
  authHandoff.then(renderApp).catch((error: Error) => {
    root.render(
      <div role="alert" style={{ padding: '2rem' }}>
        Unable to authenticate this tab: {error.message}
      </div>
    );
  });
} else {
  renderApp();
}

// serviceWorkerRegistration.register();
serviceWorkerRegistration.unregister();
